/**
 * API CEI Apps
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `GRADUADA` - Graduada * `INCUBADA` - Incubada * `PRE_INCUBADA` - Pré-incubada * `SUSPENSAO` - Suspensão
 */
export enum StatusIncubacaoEnum {

    GRADUADA = 'GRADUADA',

    INCUBADA = 'INCUBADA',

    PRE_INCUBADA = 'PRE_INCUBADA',

    SUSPENSAO = 'SUSPENSAO'
}

